import { Link } from '@hub/link'
import { Logo } from '@hub/logos'
import React, { useContext } from 'react'
import { HubStyleObject } from '@hub/design-system-base'
import { LinkContext } from '../../../context'

interface UniversalHeaderLogosProps {
  logo?: React.ComponentProps<typeof Logo>['variant']
  mono?: React.ComponentProps<typeof Logo>['mono']
  boxSize?: React.ComponentProps<typeof Logo>['boxSize']
  sx?: HubStyleObject
  url?: string
}

export const UniversalHeaderLogos: React.FC<UniversalHeaderLogosProps> = ({
  logo,
  mono,
  boxSize,
  sx,
  url = '/',
}) => {
  const RouterLink = useContext(LinkContext)
  return (
    <Link as={props => <RouterLink to={url} {...props} />} href={url} sx={sx}>
      <Logo variant={logo} mono={mono} boxSize={boxSize} />
    </Link>
  )
}
